"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var spriteStyles = require('owa-sprite/dist/styles/ribbon_sprite.css');
var styles = require('./MessageFormatFull.scss');
var classNames = require('classnames/bind').bind(styles);
var FormatButton = /** @class */ (function (_super) {
    tslib_1.__extends(FormatButton, _super);
    function FormatButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick(!_this.props.isSelected);
            }
        };
        return _this;
    }
    FormatButton.prototype.render = function () {
        return (React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.icon, type: this.props.type, className: classNames(styles.formatButton, {
                isSelected: this.props.isSelected,
            }), "data-is-focusable": true, title: owa_common_strings_1.default[this.props.type], onClick: this.onClick },
            React.createElement("span", { className: spriteStyles["ribbon-icon-" + this.props.type] })));
    };
    return FormatButton;
}(React.Component));
exports.default = FormatButton;
//# sourceMappingURL=FormatButton.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/components/FormatButton.js
// module id = 3740
// module chunks = 2